import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Trash: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5 3V1a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v2H.75a.75.75 0 0 0 0 1.5h.75V13a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4.5h.75a.75.75 0 0 0 0-1.5H11.5ZM6 1.5V3h4V1.5H6Zm7 3H3V13a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 13 13V4.5Z"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.25 6.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Zm3.5 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75Z"
            ></path>
        </Icon>
    );
};
